import React from 'react';
import { Box, ModuleBase, Text, Stack, Link, ResponsiveImage } from '@/components';
import classNames from 'classnames';
import { animControllerInView, fadeIn } from '@/animations';
import { SideBySideModuleModel } from './SideBySideModule';

const AdvisoryInvest = (data: SideBySideModuleModel) => {
  const { alignment, title, cards, image, link1, link2 } = data.props;

  return (
    <ModuleBase
      noPadding
      data={{ ...data, props: { ...data.props, backgroundColour: '#F3FE88' } }}
      className={classNames(
        'AdvisoryInvest relative flex flex-col items-center lg:flex-row',
        alignment === 'Right' ? 'justify-end' : 'justify-start',
      )}
    >
      {image && (
        <Stack
          animation={animControllerInView({ amount: 0.3 })}
          className="relative aspect-square w-full overflow-hidden sm:aspect-[unset] sm:h-[500px] lg:min-h-[750px] lg:w-1/2 xl:min-h-[800px]"
        >
          {image && image.desktopImage && (
            <ResponsiveImage
              animation={fadeIn}
              image={image.desktopImage}
              widths={{ xs: 425, sm: 650, md: 758, lg: 512, xl: 720, xxl: 950 }}
              heights={{ xs: 425, sm: 500, md: 500, lg: 750, xl: 850, xxl: 850 }}
            />
          )}
          <div className="absolute top-2/4 left-2/4 block aspect-square h-full -translate-x-2/4 -translate-y-2/4 rounded-full border border-white lg:h-auto lg:w-full" />
        </Stack>
      )}

      <div className="left-0 flex w-full items-center py-10 lg:absolute lg:h-full lg:py-0">
        <div
          className={classNames(
            'container flex lg:h-full lg:py-8 xl:py-18',
            alignment === 'Right' ? 'lg:justify-start' : 'lg:justify-end',
          )}
        >
          <Stack
            className={classNames(
              'flex w-full flex-col lg:w-1/2 lg:justify-between',
              alignment === 'Right' ? 'lg:pr-9' : 'lg:pl-9',
            )}
          >
            {title && (
              <Text
                className="text-style-h2 pr-10 md:pr-20 lg:pr-0 lg:!text-[75px] lg:leading-[75px] xl:w-[90%]"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
            <div className="w-full">
              {cards && (
                <div className="mt-10 flex-col gap-5">
                  {cards.map((card, index) => (
                    <Box
                      key={index}
                      className="border-from-bg mt-4 flex flex-col gap-1 border-b border-solid pb-4 first:pt-4 last:border-b-0"
                    >
                      <p className="text-style-h5">{card.title}</p>
                    </Box>
                  ))}
                </div>
              )}
              <div className="flex gap-5">
                {link1 && (
                  <Link
                    animate
                    className="btn primary v2 mt-10 !text-[#F3FE88] hover:!text-black lg:mt-8"
                    link={link1}
                  />
                )}
                {link2 && <Link animate className="btn secondary v2 mt-10 lg:mt-8" link={link2} />}
              </div>
            </div>
          </Stack>
        </div>
      </div>
    </ModuleBase>
  );
};

export default AdvisoryInvest;
